import { useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import type { AccountModel, LoaiTSCDCCDC, LoaiTSCDCCDCInput, Phi } from '@/types/schemas';
import { formSchema, initialValues, type FormValues } from '../schemas';
import { FormMode } from '@/types/form';
import BasicForm from './BasicForm';

interface FormDialogProps {
  mode: FormMode;
  open: boolean;
  onClose: () => void;
  onSubmit?: (data: LoaiTSCDCCDCInput) => void;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  onWatchButtonClick?: () => void;

  initialData?: LoaiTSCDCCDC | null;
}
function FormDialog({
  mode,
  open,
  onClose,
  onAddButtonClick,
  onCopyButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  initialData,
  onSubmit
}: FormDialogProps) {
  // State management for search fields
  const [assetAccount, setAssetAccount] = useState<AccountModel | null>(initialData?.tk_ts_data || null);
  const [depreciationAccount, setDepreciationAccount] = useState<AccountModel | null>(initialData?.tk_kh_data || null);
  const [expenseAccount, setExpenseAccount] = useState<AccountModel | null>(initialData?.tk_cp_data || null);
  const [fee, setFee] = useState<Phi | null>(initialData?.ma_phi_data || null);

  const handleSubmit = async (data: FormValues) => {
    try {
      const formData = {
        ...data,
        tk_ts: assetAccount?.uuid || '',
        tk_kh: depreciationAccount?.uuid || '',
        tk_cp: expenseAccount?.uuid || '',
        ma_phi: fee?.uuid || ''
      } as LoaiTSCDCCDCInput;
      onSubmit?.(formData);
    } catch (err: unknown) {
      console.error('Error submitting form:', err);
    }
  };
  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem'}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2<FormValues>
          mode={mode}
          hasAritoActionBar={false}
          schema={formSchema}
          onSubmit={handleSubmit}
          initialData={(initialData || initialValues) as Partial<FormValues>}
          className='w-full min-w-[800px]'
          headerFields={
            <BasicForm
              formMode={mode}
              assetAccount={assetAccount}
              setAssetAccount={setAssetAccount}
              depreciationAccount={depreciationAccount}
              setDepreciationAccount={setDepreciationAccount}
              expenseAccount={expenseAccount}
              setExpenseAccount={setExpenseAccount}
              fee={fee}
              setFee={setFee}
            />
          }
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default FormDialog;
